import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "sf-image-text px-4 sm:px-0 pb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sf-image-text__overlay" }, null, -1)
const _hoisted_3 = { class: "relative px-6 py-12 max-w-2xl" }
const _hoisted_4 = { class: "sf-image-text__title text-2xl md:text-4xl font-bold text-white" }
const _hoisted_5 = {
  key: 0,
  class: "sf-image-text__text mt-3 text-white/90 text-sm md:text-base"
}
const _hoisted_6 = {
  key: 1,
  class: "sf-image-text__split grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "sf-heading text-2xl md:text-3xl font-bold" }
const _hoisted_9 = {
  key: 0,
  class: "sf-image-text__text mt-3 text-sm md:text-base whitespace-pre-line"
}

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ImageTextSection } from '@/global/state/StorefrontState'
import { openStorefrontLink, resolveMediaUrl } from '../storefrontUtils'

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageTextSection',
  props: {
    section: {}
  },
  setup(__props: any) {

const props = __props
const router = useRouter()

const position = computed(() => props.section.settings?.imagePosition ?? 'left')
const imageUrl = computed(() => resolveMediaUrl(props.section.settings?.imageUrl))
const hasButton = computed(() => !!props.section.settings?.buttonText && !!props.section.settings?.buttonLink)

function onButtonClick() {
  openStorefrontLink(router, props.section.settings.buttonLink)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (position.value === 'background')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sf-image-text__bg flex items-center justify-center text-center",
          style: _normalizeStyle(imageUrl.value ? { backgroundImage: `url('${imageUrl.value}')` } : {})
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.section.settings.title), 1),
            (_ctx.section.settings.text)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.section.settings.text), 1))
              : _createCommentVNode("", true),
            (hasButton.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "sf-image-text__button mt-6",
                  onClick: onButtonClick
                }, _toDisplayString(_ctx.section.settings.buttonText), 1))
              : _createCommentVNode("", true)
          ])
        ], 4))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (imageUrl.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["sf-image-text__media", position.value === 'right' ? 'md:order-2' : ''])
              }, [
                _createElementVNode("img", {
                  src: imageUrl.value,
                  alt: _ctx.section.settings.title,
                  loading: "lazy"
                }, null, 8, _hoisted_7)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([position.value === 'right' ? 'md:order-1' : '', !imageUrl.value ? 'md:col-span-2 text-center' : ''])
          }, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.section.settings.title), 1),
            (_ctx.section.settings.text)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.section.settings.text), 1))
              : _createCommentVNode("", true),
            (hasButton.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "sf-image-text__button mt-6",
                  onClick: onButtonClick
                }, _toDisplayString(_ctx.section.settings.buttonText), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]))
  ]))
}
}

})